import { ServiceBase } from 'travco-services';

class PricingService extends ServiceBase {

    constructor(token) {
        super();
        this._token = token;
    }

    overridePricing(pricingList, selected) {
        return super.fetch('/api/pricing/OverridePricing', 'post', JSON.stringify({ pricingList: pricingList, selected: selected }), this._token);
    }

    searchPricing(filters) {
        return super.fetch('/api/pricing/SearchPricing', 'post', JSON.stringify(filters), this._token);
    }

    searchPricingHotels(filters) {
        let request = {
            countryId: filters.country !== null ? filters.country.id : null,
            cityId: filters.city !== null ? filters.city.id : null,
            hotelName: filters.hotelName,
            rateReference: filters.rateReference,
            dateFrom: filters.dateFrom,
            dateTo: filters.dateTo
        };
        return super.fetch('/api/pricing/SearchPricingHotels', 'post', JSON.stringify(request), this._token);
    }
}

export default PricingService;
